import React from 'react'

import { BackButton, Button, Form, Page } from '@fielded/shared-ui'
import { Arrow } from '@fielded/shared-ui/src/icons'

import PickUpContentsTable from '../component/PickUpContentsTable/PickUpContentsTable'

const AdjustPickup = ({
  formRef,
  history,
  deliveries,
  driverName,
  onProceed,
  isAdjusted,
  withAdjustmentsFeature
}) => {
  return (
    <Page situation={isAdjusted ? 'caution' : 'ready'}>
      <Page.Header
        backButton={<BackButton history={history}>go back</BackButton>}
      />
      {isAdjusted && (
        <Page.Panel>
          <Page.Panel.Message
            fullWidth
            type='warning'
            title='Quantities updated'
          >
            Product quantities have been adjusted.
          </Page.Panel.Message>
        </Page.Panel>
      )}
      <Page.Intro title='Confirm pickup' />
      <Page.Panel withBackground>
        <Page.Panel.Section fullWidth>
          <PickUpContentsTable
            shipments={deliveries}
            history={history}
            isEditable={withAdjustmentsFeature}
            withAdjustmentsFeature={withAdjustmentsFeature}
          />
        </Page.Panel.Section>

        <Page.Panel.Section className='confirm-pick-up__form-wrapper' fullWidth>
          <Form ref={formRef}>
            <Form.Section>
              <Form.Row>
                <Form.Field
                  fieldName='warehouseManagerName'
                  labelText='Warehouse manager’s name'
                  spread
                >
                  <Form.Field.Text
                    defaultValue=''
                    required='Please enter a name'
                  />
                  <Form.Field.ValidationErrors />
                </Form.Field>
              </Form.Row>

              <Form.Row>
                <Form.Field
                  fieldName='warehouseManagerPhoneNumber'
                  labelText='Warehouse manager’s phone number'
                  spread
                >
                  <Form.Field.Text
                    defaultValue=''
                    required='Please enter a phone number'
                  />
                  <Form.Field.ValidationErrors />
                </Form.Field>
              </Form.Row>
            </Form.Section>

            <Form.Row>
              <Form.Field
                fieldName='comment'
                labelText='If you have any comment note it here'
                className='confirm-pick-up__comment-label'
                spread
              >
                <Form.Field.Text
                  defaultValue=''
                  rows={5}
                />
              </Form.Field>
            </Form.Row>
          </Form>
        </Page.Panel.Section>
      </Page.Panel>

      <Page.Footer layout='centered'>
        <Button
          fill='full'
          size='large'
          colorVariant='confirmation'
          iconSide='right'
          icon={<Arrow direction='right' />}
          onClick={onProceed}
        >
          Proceed
        </Button>
      </Page.Footer>
    </Page>
  )
}

export default AdjustPickup
